import { Page } from '@/core/architecture'

import { MyProfileTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyProfile Page
 * Implemented as a practical sample.
 */
export const MyProfile: Page = () => {
  const { state } = useViewModel()

  return <MyProfileTemplate state={state} />
}
